import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router";
import { SubMenuProps } from "./SubMenu";
import useBuildingMenu from "./useBuildingMenu";

interface MenuItemProps {
  name: string;
  path?: string;
  icon?: React.ReactNode;
  subtitle?: string;
  subMenu?: SubMenuProps[];
}

const SubMenuItem = ({ item }: { item: MenuItemProps }) => {
  const navigate = useNavigate();
  const { isMenuSelected } = useBuildingMenu();
  const isSelected = isMenuSelected(item);

  const navigateToPath = () =>
    item.path &&
    navigate(item.path, { replace: true, state: location.pathname });

  return (
    <div
      className={clsx(
        "flex items-center py-[10px] px-3 hover:bg-indigo-50 cursor-pointer group/subItem rounded-md relative transition",
        "text-sm font-medium whitespace-normal mb-[10px] last-of-type:mb-0",
        { "bg-indigo-50": isSelected }
      )}
      onClick={navigateToPath}
    >
      <div
        className={clsx(
          "text-gray-500 group-hover/subItem:text-white transition",
          "rounded-md p-2 bg-gray-50 group-hover/subItem:bg-indigo-500 w-[40px] min-h-[40px]",
          { "bg-indigo-500 text-white": isSelected }
        )}
      >
        {item.icon}
      </div>
      <div className="ml-4 text-sm">
        <div
          className={clsx(
            "text-gray-900 group-hover/subItem:text-indigo-700 font-medium mb-1 transition",
            { "text-indigo-700": isSelected }
          )}
        >
          {item.name}
        </div>
        <div
          className={clsx(
            "text-gray-600 group-hover/subItem:text-indigo-500 transition text-sm font-normal",
            { "text-indigo-500": isSelected }
          )}
        >
          {item.subtitle}
        </div>
      </div>
    </div>
  );
};

export default SubMenuItem;
